import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import ActiveLearningClassDataContents from "../../../templates/teacher/ActiveLearningClassDataContents";
import {
  Context,
  fetchActiveLearningStudentAnswers,
  fetchActiveLearningThemes,
  fetchActiveLearningMaterialLessonsData,
  fetchClassesByGrade,
} from "../../../teacherStore";
import appStyles from "../../../App.module.scss";

export default () => {
  const { dispatch } = useContext(Context);
  const { class_id, student_id } = useParams();

  useEffect(() => {
    dispatch(fetchActiveLearningThemes());
    dispatch(fetchActiveLearningMaterialLessonsData());
    dispatch(fetchClassesByGrade());
  }, [dispatch]);

  // 画面遷移後にスクロール位置が下がっている場合があるため、スクロール位置を先頭に戻す
  useEffect(() => {
    const contentElement = document.querySelector(`.${appStyles.content}`);

    if (!contentElement) return;
    contentElement.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchActiveLearningStudentAnswers(Number(student_id)));
  }, [class_id, student_id, dispatch]);

  return <ActiveLearningClassDataContents />;
};
